export function viewThreeComplete(state) {
  return {
    ...state,
    designChapter: {
      ...state.designChapter,
      STEPS: updateShowFeedbackInSteps(state.designChapter.STEPS),
    },
  };
}

function updateShowFeedbackInSteps(steps) {
  return { ...steps, showFeedback: false };
}
